export default function () {
    return (document.querySelector("meta[name='_csrf']") as any)["content"]
}
